<template>
  <div class="card bg-light border-0">
    <div class="card-body py-2">
      <p class="text-center text-muted mb-0">There are no available times.</p>
    </div>
  </div>
</template>

<script charset="utf-8">
export default {
  name: "NoTimes",
};
</script>
